import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { BUY_URL } from '../data/content';
interface BuyButtonProps {
  label?: string;
  className?: string;
  fullWidth?: boolean;
}
export function BuyButton({
  label = 'Quiero el pack definitivo',
  className = '',
  fullWidth = true
}: BuyButtonProps) {
  return <motion.a href={BUY_URL} target="_blank" rel="noopener noreferrer" whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.03, 1]
  }} transition={{
    repeat: Infinity,
    duration: 2.2,
    ease: 'easeInOut'
  }} className={`group inline-flex items-center justify-center gap-2 rounded-xl bg-[#F5C518] px-6 py-4 text-center font-oswald text-base font-700 uppercase tracking-wide text-black shadow-[0_8px_30px_rgba(245,197,24,0.35)] transition-colors hover:bg-[#ffd633] ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-36">
      <span className="font-bold" data-id="element-37">{label}</span>
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-38" />
    </motion.a>;
}